let startDate = new Date();
const channelsPerPage = 8;

const timelineInterval = 30; // in minutes
const timelineIntervalNumbers = 8; // number of timeline intervals
const timelineLength = timelineInterval * timelineIntervalNumbers; // total length of the timeline in minutes (240)
const timelineIntervalPercent = (timelineInterval / timelineLength) * 100; // 12.5 %

const arrayGuard = function (index, arrayToCheck) {
  if (typeof arrayToCheck[index] === 'undefined') {
    return false;
  }
  return true;
};

if(!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLengthIn, padStringIn) {
      var targetLength = targetLengthIn>>0; //truncate if number or convert non-number to 0;
      var padString = String((typeof padStringIn !== 'undefined' ? padStringIn : ' '));
      if(this.length > targetLength) {
          return String(this);
      } else {
          targetLength = targetLength - this.length;
          if(targetLength > padString.length) {
              padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
          }
          return padString.slice(0, targetLength) + String(this);
      }
  };
}

export const setStartDate = () => {
  startDate = new Date();
  console.log("startDate: ", startDate)
  // clone startDate
  return new Date(startDate.getTime());
}

const updateEpgStatus = function (oldProgram, program, newStatus) {
//const updateEpgStatus = function (newStatus) {
  // eslint-disable-next-line
  program.isActive = newStatus;
  // eslint-disable-next-line
  oldProgram.isActive = !newStatus;
};

const extractProgram = function (channelIndex, epgProgramIndex, tvPrograms) {
  const channel = tvPrograms[channelIndex];
  return channel[epgProgramIndex];
};

export function channelUp({
  currentChannelIndex,
  currentEpgProgramIndex,
  tvPrograms,
}) {
  const nextIndex = currentChannelIndex - 1;
  if (!arrayGuard(nextIndex, tvPrograms)) return currentChannelIndex;
  const oldProgram = extractProgram(
    currentChannelIndex,
    currentEpgProgramIndex,
    tvPrograms
  );
  const newProgram = extractProgram(nextIndex, 0, tvPrograms);

  if (newProgram) {
    updateEpgStatus(oldProgram, newProgram, true);
    return nextIndex;
  }
  // edge case for no epg data (newProgram) for channel
  const params = { currentChannelIndex, channelIndexToSkip: nextIndex, oldProgram, tvPrograms};
  return channelSkipBackwards(params);
}

const channelSkipForward = function(params) {
  return channelSkip(1, params);
}

const channelSkipBackwards = function(params) {
  return channelSkip(-1, params);
}

const channelSkip = function (step, {
  currentChannelIndex,
  channelIndexToSkip,
  oldProgram,
  tvPrograms,
}) {

  const nextIndex = channelIndexToSkip + step;

  if (!arrayGuard(nextIndex, tvPrograms)) return currentChannelIndex;
  const newProgram = extractProgram(nextIndex, 0, tvPrograms);

  if (newProgram) {
    updateEpgStatus(oldProgram, newProgram, true);
    return nextIndex;
  }
  // edge case another channel to skip
  const params = { currentChannelIndex, channelIndexToSkip: nextIndex, oldProgram, tvPrograms};
  return channelSkip(step, params);
};

export function channelDown({
  currentChannelIndex,
  currentEpgProgramIndex,
  tvPrograms,
}) {
  const nextIndex = currentChannelIndex + 1;
  if (!arrayGuard(nextIndex, tvPrograms)) return currentChannelIndex;
  const oldProgram = extractProgram(
    currentChannelIndex,
    currentEpgProgramIndex,
    tvPrograms
  );
  const newProgram = extractProgram(nextIndex, 0, tvPrograms);

  if (newProgram) {
    updateEpgStatus(oldProgram, newProgram, true);
    return nextIndex;
  }
  // edge case for no epg data (newProgram) for channel
  const params = { currentChannelIndex, channelIndexToSkip: nextIndex, oldProgram, tvPrograms};
  return channelSkipForward(params);
}

export function channelRight({
  currentChannelIndex,
  currentEpgProgramIndex,
  tvPrograms,
  currentMaxHorizontalPages,
  currentHorizontalPage,
}) {
  // test current channel
  if (!arrayGuard(currentChannelIndex, tvPrograms)) return; // do nothing when channel not there
  const currentChannel = tvPrograms[currentChannelIndex];
  const nextIndex = currentEpgProgramIndex + 1;
  const lastProgramIndex = currentChannel.length - 1;

  const oldProgram = extractProgram(
    currentChannelIndex,
    currentEpgProgramIndex,
    tvPrograms
  );

  if (nextIndex <= lastProgramIndex) {
    const newProgram = extractProgram(
      currentChannelIndex,
      nextIndex,
      tvPrograms
    );
    updateEpgStatus(oldProgram, newProgram, true);

    return {
      currentEpgProgramIndex: nextIndex,
      currentHorizontalPage: currentHorizontalPage,
    };
  }
  // next page

  return {
    currentEpgProgramIndex: 0,
    currentHorizontalPage: currentHorizontalPage + 1,

    updateActiveStatus: function (programs) {
      if (!arrayGuard(0, programs)) return 0;
      const firstProgram = programs[0];
      firstProgram.isActive = true;
      return 0;
    },
  };
}

export function channelLeft({
  currentChannelIndex,
  currentEpgProgramIndex,
  tvPrograms,
  currentHorizontalPage,
}) {
  // test current channel
  if (!arrayGuard(currentChannelIndex, tvPrograms)) return;

  const currentChannel = tvPrograms[currentChannelIndex];
  const previousIndex = currentEpgProgramIndex - 1;

  const oldProgram = extractProgram(
    currentChannelIndex,
    currentEpgProgramIndex,
    tvPrograms
  );

  if (previousIndex >= 0) {
    const newProgram = extractProgram(
      currentChannelIndex,
      previousIndex,
      tvPrograms
    );
    updateEpgStatus(oldProgram, newProgram, true);

    return {
      currentEpgProgramIndex: previousIndex,
      currentHorizontalPage: currentHorizontalPage,
    };
  }

  // go to previous page
  var currentHorizontalPage =
    currentHorizontalPage > 1 ? currentHorizontalPage - 1 : 1;

  return {
    currentEpgProgramIndex: 0, // todo: should be last index of previous page
    currentHorizontalPage: currentHorizontalPage,
    updateActiveStatus: function (programs) {
      const lastProgram = programs[programs.length - 1];
      if (lastProgram) {
        lastProgram.isActive = true;
      }
    },
    lastProgramIndex: function (programs) {
      if (!programs) return 0;
      return programs.length - 1;
    },
  };
}

const adjustTimelineStart = (startTimelineDate) => {
  let startDateCopy = new Date(startTimelineDate.getTime());
  let startMinutes = startDateCopy.getMinutes();
  const startHours = startDateCopy.getHours();
  startMinutes = startMinutes < 30 ? 0 : 30;
  startDateCopy.setMinutes(startMinutes);
  return startDateCopy;
};

export function timelinePositionMarginPercent(now) {
  const startTimelineDate = adjustTimelineStart(startDate);
  const timeperiode = now.getTime() - startTimelineDate.getTime();
  return (timeperiode / (timelineLength * 60 * 1000)) * 100;
}

const startTimelineDateForPage = function (startDate, page) {
  let startDateCopy = adjustTimelineStart(startDate); // = startTimelineDate
  // adjust starttime for page n
  startDateCopy = new Date(
    startDateCopy.getTime() + timelineLength * 60 * 1000 * (page - 1)
  );
  return startDateCopy;
};

export function timelineHeader(page = 1) {
  const intervals = timelineIntervalNumbers;
  const percent = timelineIntervalPercent;

  let startDateCopy = startTimelineDateForPage(startDate, page);

  const computeHeaderTimes = function (startDateCopy, timelineInterval) {
    const minutes = startDateCopy.getMinutes();
    const hours = startDateCopy.getHours();

    const timeInMs = startDateCopy.getTime() + timelineInterval * 60 * 1000;
    startDateCopy.setTime(timeInMs);

    const zeroPad = (num, places) => String(num).padStart(places, '0');
    return zeroPad(hours, 2) + ':' + zeroPad(minutes, 2);
  };

  const newArray = [...Array(intervals)]; // create array with x items (interval)
  // add times
  const timeArray = newArray.map(() =>
    computeHeaderTimes(startDateCopy, timelineInterval)
  );
  // add percent width
  const complete = timeArray.map((item) => ({
    time: item,
    percent: percent + '%',
  }));

  console.log('timeArray:', timeArray);
  console.log('complete:', complete);

  return complete;
}

export function groupByHorizontalPages(programs, channelIndex) {
  const timelineStartDate = new Date(startDate.getTime());

  // 1. Page startDate.getTime() + timelineLength  -> last entry
  // filter  -> last < program.startISO (page 1)
  // + program.end > startDate

  // page1 last1  = startDate + (1* timelength)
  // page2 start = last1; last2= ()
  // page2 last2 = startDate + (2* timelength)
  // page  start2 = last2 - timelength
  // page3 last3 = startDate + (3* timelength)
  // page  start3 = last3 - timelength
  // page4 last4 = startDate + (4* timelength)
  // page4 start4 = last4-timelength
  //

  // 4 * 60 * 60

  const timelineFrame = (startDate, timelength, page) => {
    const end = startDate + page * timelength;
    const start = end - timelength;
    return {
      start: start,
      end: end,
      startDate: new Date(start),
      endDate: new Date(end),
      page: page,
    };
  };

  const maxHorizontalPages = programs.reduce((max, program) => {
    const pstart = program.startISO.getTime();
    const pend = program.endISO.getTime();
    const startTimeline = timelineStartDate.getTime();

    let timeline = timelineFrame(
      startTimeline,
      timelineLength * 60 * 1000,
      max
    );

    // new page condition
    if (pend > timeline.end) {
      timeline = timelineFrame(
        startTimeline,
        timelineLength * 60 * 1000,
        max + 1
      );
    }
    return timeline.page;
  }, 1);

  //console.log('maximal pages: ', maxHorizontalPages);

  // modifiy original program -> retain original array index
  const programsForChannel = programs.map((program, index) => {
    const newPrg = { ...program, programIndex: index }; // copy + add program property: index
    return newPrg;
  });

  // horizontal paging

  const groupByHorizontalPages = (
    timelineStartDate,
    maxHorizontalPages,
    programs
  ) => {
    const newArray = [...Array(maxHorizontalPages)]; // create array with x items (maxHorizontalPages)
    return newArray.map((_, index) => {
      let pageNr = index + 1;
      return programs.filter((program) => {
        const pstart = program.startISO.getTime();
        const pend = program.endISO.getTime();
        const startTimeline = timelineStartDate.getTime();
        let timeline = timelineFrame(
          startTimeline,
          timelineLength * 60 * 1000,
          pageNr
        );
        const inPage = pstart < timeline.end && pend > timeline.start;
        return inPage;
      });
    });
  };

  const programsByPages = groupByHorizontalPages(
    timelineStartDate,
    maxHorizontalPages,
    programsForChannel
  );

  //console.log('programs by pages: ', programsByPages);
  return programsByPages;
}

// horizontal page
export function getEpgForPage(pageNr, programsByPages) {
  // loop channels
  const programsForPage = programsByPages.map((program, channelIndex) => {
    if (arrayGuard(pageNr - 1, program)) {
      return program[pageNr - 1];
    }
    // no program found
    return [];
  });

  console.log('programs for page: ' + pageNr, programsForPage);
  return programsForPage;
}

export function highlightFirstProgram(epgChannels, channelIndex) {
  if (!arrayGuard(channelIndex, epgChannels)) return epgChannels;
  const firstChannel = epgChannels[channelIndex];
  if (!arrayGuard(0, firstChannel)) return epgChannels;
  const firstProgram = firstChannel[0];
  firstProgram.isActive = true;
  return epgChannels;
}

export function timelineStartDate() {
  return new Date(startDate.getTime());
}

export function computeMaxChannelPages(numberOfChannels) {
  const maxPagesTmp = numberOfChannels / channelsPerPage;
  const remainder = numberOfChannels % channelsPerPage;
  if (remainder === 0) return maxPagesTmp;
  return Math.ceil(maxPagesTmp);
}

export function computeChannelPage(currentChannelIndex, numberOfChannels) {
  const pos = (currentChannelIndex + 1) % channelsPerPage;
  const pageNr = Math.ceil((currentChannelIndex + 1) / channelsPerPage);
  return {
    currentChannelPageNr: pageNr,
    currentChannelPos: pos === 0 ? channelsPerPage : pos,
  };
}

export function addPageNrToChannels(channels) {
  const maxChannels = channels.length;
  const channelsPaged = channels.map((channel, index) => {
    const info = computeChannelPage(index, maxChannels);
    const newChn = { ...channel, pageNr: info.currentChannelPageNr }; // copy + add new pageNr property
    return newChn;
  });
  return channelsPaged;
}

export function sortAndFilterChannels({ channels }) {
  let tvOnlyChannels = channels.filter(
    (channel) => channel.serviceType === 'tv'
  );
  return tvOnlyChannels.sort((a, b) => a.position - b.position);
}

export function filterChannelsForPage(currentChannelPageNr, channels) {
  return channels.filter((channel) => {
    return currentChannelPageNr === channel.pageNr;
  });
}

export function eventlist(programs, channelIndex, pageNr = 1) {
  // visible timeline
  let timelineLengthInSeconds = timelineLength * 60;

  const pageStartTimelineDate = startTimelineDateForPage(startDate, pageNr);

  let availableTimePercent = 100;
  let testTimePercent = 0;

  const adjustProgramStart = (pstart) => {
    const isProgramAlreadyStarted = pstart < pageStartTimelineDate.getTime();
    if (!isProgramAlreadyStarted) return pstart / 1000; // return program start time in seconds
    return pageStartTimelineDate.getTime() / 1000; // return program start time in seconds
  };

  const programDurationInPercent = (program) => {
    const starttime = adjustProgramStart(program.startISO.getTime());
    const endtime = program.endISO.getTime() / 1000; // programm end time in seconds
    const duration = endtime - starttime; // program duration in seconds
    return Math.round((duration / timelineLengthInSeconds) * 100); // program duration in percent in relation to whole visible timeline on screen
  };

  // filter visible programs
  const visiblePrograms = programs.filter((program) => {
    if (availableTimePercent <= 0) return false;
    const percent = programDurationInPercent(program);
    availableTimePercent = availableTimePercent - percent;
    return true;
  });

  //console.log('programm list for channelId: ', channelIndex);
  //console.log('visible programs: ', visiblePrograms);

  const programList = visiblePrograms.map((program, index, arr) => {
    let percent = programDurationInPercent(program);
    const newProgram = {
      title: program.name,
      description: program.text,
      start: program.start,
      startISO: program.startISO,
      endISO: program.endISO,
      end: program.end,
      percent: percent,
      channelIndex: channelIndex,
      epgIndex: index,
      programIndex: program.programIndex,
      id: program.id,
      isActive: false,
    };

    // modify last program percentage when not fit into visible timeline
    if (availableTimePercent <= 0 && index === arr.length - 1) {
      //console.log('modify last programm percent: ', percent);
      newProgram.percent = newProgram.percent + availableTimePercent - 0.2;
      // for some reason timeline 100 % breaks sometimes -> -0.2 to be under 100%
      // could  padding/margins responsible ??? -> occurs only when lot of programs per timeframe ???
    }

    // only for debugging
    testTimePercent = testTimePercent + newProgram.percent;

    //console.log('program: ', program);
    //console.log('program new: ', newProgram);
    //console.log('testTimePercent: ', testTimePercent, channelIndex);
    return newProgram;
  });

  return programList;
}

export let toJson = function (xmlDOM) {
  //var parser = new DOMParser();
  //var xmlDOM = parser.parseFromString(xmlString, 'text/xml');
  function convertEPGDate(epgTimeStr) {
    var convertedTime;
    if (epgTimeStr.indexOf(' ') == -1) {
      // Triax EPG Server
      convertedTime = +epgTimeStr * 1000;
    } else {
      // MCX EPG Server
      convertedTime = epgTimeStr.replace(/-/g, '/') + ' UTC';
    }
    return new Date(convertedTime);
  }

  function toTimeString(date) {
    return date.toString().substr(16, 5);
  }
  var event = xmlDOM.getElementsByTagName('event');
  var eventLength = event.length;
  var epgJSON = new Array();
  //logger.log('event ->'+deviceAPI.tool.dump(event));
  for (var x = 0; x < eventLength; x++) {
    var item = {};
    var eventId = event[x].getElementsByTagName('event_id');
    if (eventId.length > 0) {
      item.id = eventId[0].textContent;
    }
    var eventName = event[x].getElementsByTagName('event_name');
    if (eventName.length > 0) {
      item.name = eventName[0].textContent;
    }
    var eventText = event[x].getElementsByTagName('event_text');
    if (eventText.length > 0) {
      item.text = eventText[0].textContent;
    }
    var eventStart = event[x].getElementsByTagName('start_time');
    if (eventStart.length > 0) {
      item.startISO = convertEPGDate(eventStart[0].textContent);
      item.start = toTimeString(item.startISO);
    }
    var eventEnd = event[x].getElementsByTagName('end_time');
    if (eventEnd.length > 0) {
      item.endISO = convertEPGDate(eventEnd[0].textContent);
      item.end = toTimeString(item.endISO);
    }
    var eventDescription = event[x].getElementsByTagName('extended_event_text');
    if (eventDescription.length > 0) {
      item.description = eventDescription[0].textContent;
    }
    epgJSON.push(item);
  }
  return epgJSON;
};



// WEBPACK FOOTER //
// ./src/helpers/EpgGuide.js